import RestService from './RestService';

export async function getMisc(hk, sk) {
    const res = await RestService.performRestOpNext(`misc/get`, {
        hk, sk, ttl: 1000 * 60
    });
    return res;
}

